// extracted by css-extract-rspack-plugin
export default {"ThreadTitle":"ThreadTitle-module__ThreadTitle__vK9Gi","fileName":"ThreadTitle-module__fileName__dx1vP","lines":"ThreadTitle-module__lines__SZ0eW"};